import React from 'react';
import Navbar from '../global-components/navbar';
import PageHeader from '../global-components/page-header';
import RegistrationSection from '../section-components/registration';
import Footer from '../global-components/footer';
import {useHistory} from "react-router-dom";
import {REGISTER} from "../../actions/types";

const Auth = () => {
    window.scrollTo(0, 0);
    const history = useHistory();
    let pageTitle = '';
    if (window.location.pathname === '/register') {
        pageTitle = 'Login / Register';
    } else if (window.location.pathname === '/mobile-verification') pageTitle = 'Mobile Verification';
    else if (window.location.pathname === '/change-mobile-number') pageTitle = 'Change Mobile Number';

    return <div>
        <Navbar scenario={REGISTER}/>
        <PageHeader headertitle={pageTitle}/>
        <RegistrationSection history={history}/>
        <Footer/>
    </div>
};

export default Auth

